import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user" }, null, -1)
const _hoisted_2 = { class: "el-form-item__label" }
const _hoisted_3 = { class: "value" }
const _hoisted_4 = { class: "company-siret" }
const _hoisted_5 = { class: "company-activity" }
const _hoisted_6 = { class: "company-city" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-building" }, null, -1)
const _hoisted_8 = { class: "el-form-item__label" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-building" }, null, -1)
const _hoisted_10 = { class: "el-form-item__label" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-star" }, null, -1)
const _hoisted_12 = { class: "el-form-item__label" }
const _hoisted_13 = { class: "rating-container" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user-tie" }, null, -1)
const _hoisted_15 = { class: "el-form-item__label" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-phone" }, null, -1)
const _hoisted_17 = { class: "el-form-item__label" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-mobile" }, null, -1)
const _hoisted_19 = { class: "el-form-item__label" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-map-marker-alt" }, null, -1)
const _hoisted_21 = { class: "el-form-item__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_crm_account_type_select = _resolveComponent("crm-account-type-select")!
  const _component_crm_account_potential_select = _resolveComponent("crm-account-potential-select")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_crm_user_select = _resolveComponent("crm-user-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "formComponent",
            rules: _ctx.rules,
            model: _ctx.form,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { prop: "companyName" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AccountCreation.CompanyNameLabel")), 1),
                  _createVNode(_component_el_autocomplete, {
                    modelValue: _ctx.form.companyName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.companyName) = $event)),
                    class: "form-item-content",
                    "popper-class": "company-popper",
                    "trigger-on-focus": false,
                    "fetch-suggestions": _ctx.searchCompanies,
                    onSelect: _ctx.setCompanyInformation
                  }, {
                    default: _withCtx(({ item }) => [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(item.l1_normalisee), 1),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(item.siret), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(item.libelle_activite_principale), 1),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(item.l6_normalisee), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "fetch-suggestions", "onSelect"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "type" }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AccountCreation.TypeLabel")), 1),
                  _createVNode(_component_crm_account_type_select, {
                    modelValue: _ctx.form.type,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.type) = $event)),
                    class: "form-item-content"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "potentialId" }, {
                default: _withCtx(() => [
                  _hoisted_9,
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AccountCreation.PotentialLabel")), 1),
                  _createVNode(_component_crm_account_potential_select, {
                    modelValue: _ctx.form.potentialId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.potentialId) = $event)),
                    class: "form-item-content"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "rating" }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("AccountCreation.RatingLabel")), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_el_rate, {
                      modelValue: _ctx.form.rating,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.rating) = $event)),
                      max: 4
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "contactManagerId" }, {
                default: _withCtx(() => [
                  _hoisted_14,
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("AccountCreation.ManagerLabel")), 1),
                  _createVNode(_component_crm_user_select, {
                    modelValue: _ctx.form.accountManagerId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.accountManagerId) = $event)),
                    class: "form-item-content",
                    "seller-only": true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "phone" }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("AccountCreation.OfficePhoneLabel")), 1),
                  _createVNode(_component_el_autocomplete, {
                    modelValue: _ctx.form.phone,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.phone) = $event)),
                    class: "form-item-content",
                    "fetch-suggestions": _ctx.searchOtherPhones
                  }, null, 8, ["modelValue", "fetch-suggestions"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "mobile" }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("AccountCreation.MobilePhoneLabel")), 1),
                  _createVNode(_component_el_autocomplete, {
                    modelValue: _ctx.form.mobile,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.mobile) = $event)),
                    class: "form-item-content",
                    "fetch-suggestions": _ctx.searchMobilePhones
                  }, null, 8, ["modelValue", "fetch-suggestions"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { prop: "unstructuredAddress" }, {
                default: _withCtx(() => [
                  _hoisted_20,
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("AccountCreation.AddressLabel")), 1),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.unstructuredAddress,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.unstructuredAddress) = $event)),
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["rules", "model"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}